import { jsx as t } from "react/jsx-runtime";
import { makeClassesByStyles as m } from "../../../../utils/classes.js";
import { Icon as s } from "../icon/icon.js";
const c = m(), i = ({ className: o, onClick: n, iconName: r, ...e }) => /* @__PURE__ */ t("button", { className: c("IconButton", o), onClick: n, type: "button", ...e, children: /* @__PURE__ */ t(s, { name: r }) });
export {
  i as IconButton
};
